import { Pipe, PipeTransform } from '@angular/core';
import flatpickr from 'flatpickr';
import { DatepickerDirective } from '../directives/datepicker.directive';

@Pipe({
  name: 'datepickerDate',
  standalone: true,
})
export class DatepickerDatePipe implements PipeTransform {
  transform(date?: string | Date | number | null): string {
    if (typeof date === 'string') {
      if (date.length < 1) {
        return '';
      }

      const parsedDate: Date | undefined = flatpickr.parseDate(date, DatepickerDirective.DATA_FORMAT)
      return parsedDate ? flatpickr.formatDate(parsedDate, DatepickerDirective.DISPLAY_FORMAT) : '';
    }

    if (typeof date === 'number') {
      date = new Date(date);
    }

    if (date) {
      return flatpickr.formatDate(date, DatepickerDirective.DISPLAY_FORMAT);
    }

    return '';
  }
}
